export const NO_SPECIAL_CHARACTERS = "Invalid Entry! Special Characters are not allowed."
export const NO_NUMBERS_AND_SPECIAL_CHARACTERS = "Invalid Entry! Special Characters & Numbers are not allowed."
export const ONLY_NUMBERS = "Invalid Entry! Only numbers are allowed."
export const LIMITED_SPECIAL_CHARACTERS = "Invalid Entry! Some special characters are not allowed!"